import {createAction} from 'redux-actions'

export const fetch = createAction('DEVICES/REFERENCE/FETCH', (type) => ({type}))
export const receive = createAction('DEVICES/REFERENCE/RECEIVE', (type, reference) => ({type, reference}))
